module.exports = __webpack_public_path__ + "img/sleep.be5030ca.webp";